import * as Toggle from '@radix-ui/react-toggle';
import { cs } from '@bbkAdminUtils/css-utils';

export const Switch = ({
  id,
  enabled,
  onToggle,
}: {
  id: string;
  enabled: boolean;
  onToggle: () => void;
}) => {
  return (
    <Toggle.Root
      id={id}
      pressed={enabled}
      onPressedChange={onToggle}
      aria-label={`Toggle ${id}`}
      className={cs(
        'tw-relative tw-inline-block tw-h-6 tw-w-12 tw-rounded-full tw-transition tw-duration-200 tw-ease-in-out',
        enabled
          ? 'tw-bg-[color-mix(in_srgb,var(--pricingtable-style-accent-color)_80%,transparent)]'
          : 'tw-bg-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_5%,transparent)]'
      )}
    >
      <span
        className={cs(
          'tw-absolute tw-inset-y-0 tw-left-0 tw-h-6 tw-w-6 tw-transform tw-rounded-full tw-bg-white/90 tw-shadow-md tw-transition-transform tw-duration-200',
          enabled ? 'tw-translate-x-6' : 'tw-translate-x-0'
        )}
      />
    </Toggle.Root>
  );
};
